import { store } from '../store'
import { logout } from '../actions/auth-actions'
import { replace } from '../actions/nav-actions'
import { notify } from '../utils'

const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "user-agent": `masar-web-app`
}

const request = (method = 'GET') => {
    return (url, options = {}) => {
        let params = {
            method,
            headers: { ...defaultHeaders },
            mode: 'cors'
        }
        if (method !== 'GET' && options.data) params.body = JSON.stringify(options.data);
        if (options.token) params.headers.Authorization = `Baerer ${options.token}`;
        return fetch(url, params)
            .then(r => {
                if (r.status === 401) {
                    store.dispatch([
                        logout(),
                        replace('/')
                    ]);
                    notify("Credentials", "revoked credentials, try again", "error");
                }
                return r.json()
            })
            .then(r => {
                if (r.error) throw new Error(r.error.message);
                return r;
            });
    }
}

export const get = request("GET");
export const put = request("PUT");
export const post = request("POST");
export const rdelete = request("DELETE");



// WEBPACK FOOTER //
// ./src/api/methods.js